export interface AcneScarOption {
    key: string
    label: string
    tooltip: string
}

export const ACNE_SCAR_OPTIONS: AcneScarOption[] = [
    {
        key: 'icepick',
        label: 'Icepick',
        tooltip: 'Cicatrizes estreitas e profundas em forma de "V", que se estendem verticalmente na pele — geralmente na testa e bochechas superiores. Costumam exigir tratamentos mais agressivos (ex: TCA CROSS).',
    },
    {
        key: 'boxcar',
        label: 'Boxcar',
        tooltip: 'Cicatrizes largas, com bordas bem definidas em forma de "U" — poços redondos ou ovais de bordas verticais íngremes, comuns nas bochechas e têmporas.',
    },
    {
        key: 'rolling',
        label: 'Rolling',
        tooltip: 'Ondulações superficiais e amplas, causadas por bridas fibróticas que tracionam a derme, dando um aspecto ondulado à pele, com bordas mal definidas.',
    },
    {
        key: 'hipertrofica',
        label: 'Hipertrófica',
        tooltip: 'Cicatrizes elevadas e firmes, causadas por excesso de colágeno — ao contrário das demais (deprimidas/atróficas), ficam acima do nível da pele.',
    },
]

export type AcneScarValue = string[]

export function createDefaultAcneScarValue(): AcneScarValue {
    return []
}

export function isAcneScarValueEmpty(value: AcneScarValue | null | undefined): boolean {
    return !value || value.length === 0
}
